var DualRowPackageWithJOrLLeadData = require('./dualRowPackageWithJOrLLeadData.js');
var lib_core = require("lib-core");

var SojData = function(position, angle, init) {
    DualRowPackageWithJOrLLeadData.apply(this, arguments);
};

lib_core.inherit(SojData, DualRowPackageWithJOrLLeadData);
lib_core.JsonParser.registerClass(SojData, "SojData");

module.exports = SojData;
